// fetch jobs...
const base_url = process.env.REACT_APP_BASE_URL;

export const getJobs = async () => {
  const response = await fetch(`${base_url}/jobs`);
  const jobs = await response.json();
  return jobs;
};

export const addJob = async (data) => {
  const response = await fetch(`${base_url}/jobs`, {
    method: "POST",
    body: JSON.stringify({
      title: data?.title,
      type: data?.type,
      salary: data?.salary,
      deadline: data?.deadline,
    }),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  const newJob = await response.json();
  return newJob;
};

export const editJob = async (id, data) => {
  const response = await fetch(`${base_url}/jobs/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
  });

  const updatedJob = await response.json();
  return updatedJob;
};

export const deleteJob = async (id) => {
  const response = await fetch(`${base_url}/jobs/${id}`, {
    method: "DELETE",
  });

  const deleteItem = await response.json();
  return deleteItem;
};
